import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import { Checkbox } from 'semantic-ui-react';
import InputCounter from "../InputCounter/InputCounter";

import {
  setPollName,
  setAnswerName,
  addNewAnswer,
  deleteAnswer,
  toggleClientsType,
  toggleConsultantsType,
} from '../../../redux/actions/editPoll';

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
  setPollName: value => dispatch(setPollName(value)),
  setAnswerName: (value, answerIndex) => dispatch(setAnswerName(value, answerIndex)),
  addNewAnswer: () => dispatch(addNewAnswer()),
  deleteAnswer: answerIndex => dispatch(deleteAnswer(answerIndex)),
  toggleClientsType: () => dispatch(toggleClientsType()),
  toggleConsultantsType: () => dispatch(toggleConsultantsType()),
});

class PollForm extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    submitText: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    edit: PropTypes.bool,
    setPollName: PropTypes.func.isRequired,
    setAnswerName: PropTypes.func.isRequired,
    addNewAnswer: PropTypes.func.isRequired,
    deleteAnswer: PropTypes.func.isRequired,
    toggleClientsType: PropTypes.func.isRequired,
    toggleConsultantsType: PropTypes.func.isRequired,
  };

  static defaultProps = {
    edit: false,
  };

  constructor() {
    super();
    this.state = {
      formWasSent: false,
      validationError: false,
    }
  }

  renderAnswers = (answer, i, answers) => {
    const { setAnswerName, deleteAnswer } = this.props;
    const { formWasSent } = this.state;

    let errorText = '';
    if (answer.text.length === 0) errorText = 'Вариант ответа не может быть пустым';
    if (answer.text.length > 60) errorText = 'Превышена максимальная длина варианта ответа';

    const answerError = ((answer.text.length === 0) || (answer.text.length > 60));

    const rowClass = classnames({
      'form-row': true,
      'error': formWasSent && answerError,
    });

    return(
      <div
        key={`${answer.id}_${i}`}
        className={rowClass}
      >
        {(answers.length > 2) ? (
          <button
            type="button"
            className="input-btn btn-del"
            onClick={() => deleteAnswer(i)}
          />
        ) : false}
        <InputCounter
          label={`Вариант ответа ${i + 1}`}
          value={answer.text}
          onChange={(value) => setAnswerName(value, i)}
          maxLength={60}
        />
        {(formWasSent && answerError) ? (
          <div className="input-text">{errorText}</div>
        ) : false}
      </div>
    );
  }

  onSubmitForm = () => {
    const { onSubmit } = this.props;
    const validationError = this.validateForm();
    this.setState({ formWasSent: true });
    if (!validationError) onSubmit();
  }

  validateForm = () => {
    const { poll } = this.props;
    //Текст опроса
    if ((poll.text.length === 0) || (poll.text.length > 60)) return true;
    //Текст ответов
    if ((poll.answers.some(answer => answer.text.length === 0)) 
      || (poll.answers.some(answer => answer.text.length > 60))) return true;
    //Количество ответов
    if (poll.answers.length > 255) return true;
    return false;
  }

  addAnswer = () => {
    const { addNewAnswer } = this.props;
    this.setState({ formWasSent: false });
    addNewAnswer();
  }

  render() {
    const { poll, setPollName, submitText, edit, toggleClientsType, toggleConsultantsType } = this.props;
    const { formWasSent } = this.state;

    const btnClass = classnames({
      'btn': true,
      'btn-green': true,
      'long': edit,
    });

    const pollTextError = ((poll.text.length === 0) || (poll.text.length > 60)) ? true : false;

    const rowClass = classnames({
      'form-row': true,
      'error': formWasSent && pollTextError,
    });

    let errorText = '';
    if (poll.text.length === 0) errorText = 'Название опроса не может быть пустым';
    if (poll.text.length > 60) errorText = 'Превышена максимальная длина названия опроса';

    return (
      <div className="form-wrap">
        <div className={rowClass}>
          <InputCounter
            isTextarea
            label="Название опроса"
            value={poll.text}
            onChange={setPollName}
            maxLength={60}
          />
          {(formWasSent && pollTextError) ? (
            <div className="input-text">{errorText}</div>
          ) : false}
        </div>

        {/* List of answer options */}
        {poll.answers.length !== 0 ? poll.answers.map(this.renderAnswers) : false}

        {/* Add answer */}
        {/* Maximum number of answers - 255 */}
        <div className="form-row special">
          <button
            type="button"
            disabled={poll.answers.length === 255}
            className="btn btn-add"
            onClick={() => this.addAnswer()}
          >
            <i aria-hidden="true" className="add-icon icon">
            <svg width="22" height="22" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"/>
              </svg>
            </i>
            <span>Добавить ответ</span>
          </button>
        </div>

        {/* Choosing a poll type */}
        <div className="form-row special">
          <div className="checkboxes-wrap">
            <Checkbox
              label='Для клиентов'
              checked={poll.clients}
              onChange={() => toggleClientsType()}
            />
            <Checkbox
              label='Для консультантов'
              checked={poll.consultants}
              onChange={() => toggleConsultantsType()}
            />
          </div>
        </div>
        <div className="form-row special">
            <button
              type="button"
              className={btnClass}
              onClick={() => this.onSubmitForm()}
            >
              {submitText}
            </button>
          </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PollForm);
